var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-switch',{attrs:{"active-value":_vm.tableData.activeValue,"inactive-value":_vm.tableData.inactiveValue},on:{"change":_vm.change},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}})
}
var staticRenderFns = []

export { render, staticRenderFns }